import React, { useEffect, useState } from 'react';

import { Spinner, Divider } from '@telus-uds/components-web';

import { TopBarMain } from './css';
import request from '../../../../utils/request';

import TextSearchFilter from '../TextSearchFilter';
import Block from './components/block';

const Outlets = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState();

  const fetchData = async () => {
    try {
      const result = await request.get('/get-outletIds');

      if (result && result.status === 200) {
        setApiData(result.data.outletIds);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <div className='layout-container'>
      <Divider space={2} variant={{ inverse: true }}/>
      {!apiData && <Spinner show label="Loading data..." />}
      {apiData && (
        <>
          <TopBarMain>
            <TextSearchFilter
              filterString={filterString}
              setFilterString={setFilterString}
              placeholder="Search by outlet..."
            />
          </TopBarMain>
          <Divider space={2} variant={{ inverse: true }}/>
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
      </div>
    </>
  );
};

export default Outlets;
